import React from "react";
import {
  Box,
  OutlinedInput,
  Chip,
  FormControl,
  MenuItem,
  InputLabel,
  Checkbox,
} from "@mui/material";
import Select from "@mui/material/Select";
interface ClientSelectProps {
  selectedClients?: { title: string; value: number }[];
  setSelectedClients?: (clients: { title: string; value: number }[]) => void;
  formValues?: any;
  setFormValues?: React.Dispatch<React.SetStateAction<any>>;
  minWidth?: number;
  maxWidth?: number;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  clients: { title: string; value: number }[];
}

const ClientSelect: React.FC<ClientSelectProps> = ({
  selectedClients,
  setSelectedClients,
  clients,
}) => {
  const handleSelectClient = (option: { title: string; value: any }) => {
    let selectedClientsData = [...selectedClients];

    if (!!selectedClients.find((sc) => sc.value === option.value)) {
      selectedClientsData = selectedClientsData.filter(
        (sc) => sc.value !== option.value,
      );
    } else {
      selectedClientsData = [...selectedClientsData, option];
    }

    setSelectedClients(selectedClientsData);
  };

  return (
    <FormControl sx={{ minWidth: 240, background: "white" }} size="small">
      <InputLabel id="clients-select-label">Clients</InputLabel>
      <Select
        multiple
        value={selectedClients}
        input={
          <OutlinedInput id="clients-select" label="Clients" size="small" />
        }
        renderValue={(selected) => (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            {selected.slice(0, 2).map((client) => {
              return (
                <Chip key={client.value} label={client.title} size="small" />
              );
            })}
            {selected.slice(2).length > 0 && (
              <p style={{ margin: 0 }}>+{selected.slice(2).length}</p>
            )}
          </Box>
        )}
      >
        {clients.map((client) => (
          <MenuItem
            style={{ padding: "0rem" }}
            onClick={() => handleSelectClient(client)}
          >
            <Checkbox
              style={{ marginRight: 4 }}
              checked={
                !!selectedClients.find((sc) => sc.value === client.value)
              }
            />
            {client.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ClientSelect;
